/**
 * Этот плагин разработан для использования в одном месте
 * Решения соответствующие
 */

import reducer from "./reducer"
import saga from "./saga"
import { MODULE_NAME } from "./helpers"

export { FORM_NAME } from "./helpers"
export { submitForm, initForm } from "./actions/creators"
export { selectStatus, selectAllPermissions } from "./selectors"

const name = MODULE_NAME
export { name, reducer, saga }
